export default "__VITE_ASSET__DtVmYR6m__";